export const subTotal = (productId, price) => {
  const carts = JSON.parse(localStorage.getItem("cart")) || [];
  const cartItem = carts.find(item => item.id === productId);
  return cartItem ? cartItem.quantity * price : 0;
};

export const cartList = () => {
  return JSON.parse(localStorage.getItem("cart")) || [];
};

export const quantity = (productId) => {
  const carts = JSON.parse(localStorage.getItem("cart")) || [];
  const cartItem = carts.find(item => item.id === productId);
  return cartItem ? cartItem.quantity : 0;
};

// Updated totalCost mixin with shipping
export const totalCost = () => {
  try {
    const carts = JSON.parse(localStorage.getItem("cart")) || [];
    const shipping = JSON.parse(localStorage.getItem("selectedShipping")) || { preco: 0 };
    const subtotal = carts.reduce((acc, item) => {
      const quantity = Number(item?.quantity) || 0;
      const price = Number(item?.price) || 0;
      return acc + quantity * price;
    }, 0);
    const shippingCost = Number(shipping?.preco) || 0;
    return subtotal + shippingCost;
  } catch (error) {
    console.error("Erro ao calcular o custo total:", error);
    return 0;
  }
};
// New helper function to clear shipping
export const clearShipping = () => {
  localStorage.removeItem("selectedShipping");
};

export const totalQuantity = () => {
  let totalQuantity = 0;

  let carts = JSON.parse(localStorage.getItem("cart"));
  carts.forEach((item) => {
    totalQuantity += item.quantitiy;
  });
  return totalQuantity;
};

export const allProduct = (products) => {
  let carts = JSON.parse(localStorage.getItem("cart")) || [];

  for (let i = 0; i < products.length; i++) {
    for (let j = 0; j < carts.length; j++) {
      if (products[i]._id === carts[j].id) {
        products[i].pQuantity = carts[j].quantity; // Corrigido aqui
      }
    }
  }

  return products;
};